import * as moment from 'moment';

export class CachedCollection<T>
{
	timestamp = new Date();

	constructor(public collection: T[], private cacheDurationSeconds: number = 300)
	{
		this.collection = collection;
	}

	public get isExpired(): boolean
	{
		return moment(new Date()).diff(moment(this.timestamp), 'seconds') >= this.cacheDurationSeconds;
	}

	addItem(item: T)
	{
		this.collection.unshift(item);
	}

	removeItem(item: T)
	{
		const index = this.collection.indexOf(item);
		if (index === -1)
		{ return; }
		this.collection.splice(index, 1);
	}
}
